module.exports = __webpack_public_path__ + "static/img/work2.5c6b4b66.png";